const arrayObObj = [
  {
    id: 1,
    image: "images/causesImg1.jpg",
    button: "Donate Now",
    title: "Providing education for children",
    description: "Lunch program in the US.To scarcity of resources overseas, WE Cause helping to stand in the gap. Give Today!.over the president.",
    raised: "25632",
    goal: "56321",
  },
  {
    id: 2,
    image: "images/causesImg2.jpg",
    button: "Donate Now",
    title: "Entertainment for children",
    description: "30-day state of emergency following violent protests over the president impeachment site in Malaysia Peru has declared.over the president.",
    raised: "25632",
    goal: "56321",
  },
  {
    id: 3,
    image: "images/causesImg3.jpg",
    button: "Donate Now",
    title: "Providing food for children",
    description: "Camping site in Malaysia Peru has declared a 30-day state of emergency following violent protests over.over the president impeachment site",
    raised: "25632",
    goal: "56321",
  },
  {
    id: 4,
    image: "images/causesImg4.jpg",
    button: "Donate Now",
    title: "Providing nutritious foods",
    description: "lunch program in the US.To scarcity of resources overseas, WE Cause helping to stand in the gap. Give Today!.over the president.",
    raised: "25632",
    goal: "56321",
  },
  {
    id: 5,
    image: "images/causesImg5.jpg",
    button: "Donate Now",
    title: "Providing education for children",
    description: "camping site in Malaysia Peru has declared a 30-day state.missing after a landslide hit.Peru has declared a 30-day state.missing after",
    raised: "25632",
    goal: "56321",
  },
  {
    id: 6,
    image: "images/causesImg6.jpg",
    button: "Donate Now",
    title: "Entertainment for children",
    description: "violent protests over.To scarcity of resources overseas, WE Cause helping to stand in the gap.Peru has declared a 30-day state.missing after.",
    raised: "25632",
    goal: "56321",
  },
];
export default arrayObObj;
